// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26R9l","col":"styles_col__37eiR","actions":"styles_actions__IJjSJ","conflict":"styles_conflict__CrV0v"};